  // Declare a flag to ensure the confetti triggers only once per 4pck selection
  let confettiTriggeredFor4pck = false;
  
  /***** Data Setup *****/
  const variants = {
    single: { variantId: 21174522675284, sellingPlan: 5116493961 },
    threePack: { variantId: 21174522708052, sellingPlan: 5704745097 },
    fourPack: { variantId: 39922146705545, sellingPlan: 5116362889 }
  };
  
  const bundleVariants = {
    antiAging: { variantId: 21136693493844, sellingPlan: 5116002441 },
    powerDad: { variantId: 40426830594185, sellingPlan: 5116231817 }
  };
  
  let currentTab = "buy";
  let selectedBuyVariantKey = "threePack";

  let selectedBundleVariantKey = "antiAging";
  let purchaseType = "subscription";
let selectedFrequencySet = "green";

  
  // Frequency plan variables:
  let selectedFrequencyPlanId = "5116493961";          // for 1pck (blue)
  let selectedFrequencyPlanIdThreePack = "5704745097";   // for 3pck (orange)
  let selectedFrequencyPlanIdFourPack = "5116362889";    // for 4pck (red)

  /***** Preload "Subscription Freebies" + "Freebie Progress" Images *****/
  (function preloadFreebieImages() {
    const FREEBIE_IMAGE_URLS = [
      // Freebie Progress (row2 in updateNewProgressSection)
      "https://cdn.shopify.com/s/files/1/2443/2395/files/Dr_S_Freebie_Progress_0.png?v=1769563271",
      "https://cdn.shopify.com/s/files/1/2443/2395/files/dr_s_buy_box_top_freebies_1b.png?v=1779317766",
      "https://cdn.shopify.com/s/files/1/2443/2395/files/dr_s_buy_box_top_freebies_3b.png?v=1779317768",
      "https://cdn.shopify.com/s/files/1/2443/2395/files/dr_s_buy_box_top_freebies_4b.png?v=1779317770",

      // Subscription Freebies (row2Img in updateProgressVisualsSection)
      "https://cdn.shopify.com/s/files/1/2443/2395/files/dr_s_buy_box_bottom_freebies_1b.png?v=1779317758",
      "https://cdn.shopify.com/s/files/1/2443/2395/files/dr_s_buy_box_bottom_freebies_3b.png?v=1779317761",
      "https://cdn.shopify.com/s/files/1/2443/2395/files/dr_s_buy_box_bottom_freebies_4b.png?v=1779317763",

      // OTP / hidden state image (row2Img in updateProgressVisualsSection)
      "https://cdn.shopify.com/s/files/1/2443/2395/files/Dr_S_All_Freebies_Hidden.png?v=1769561999"
    ];

    FREEBIE_IMAGE_URLS.forEach((url) => {
      const img = new Image();
      img.decoding = "async";
      img.loading = "eager";
      img.src = url;
    });
  })();

  /***** Preload Variant Button Background Images (prevents blank flicker) *****/
  (function preloadVariantButtonBgImages() {
    const VARIANT_BTN_BG_URLS = [
      // 1pck
      "https://cdn.shopify.com/s/files/1/2443/2395/files/lpsub-1pck-unselect.png?v=1741908329",
      "https://cdn.shopify.com/s/files/1/2443/2395/files/lpsub-1pck-select.png?v=1741908328",

      // 3pck
      "https://cdn.shopify.com/s/files/1/2443/2395/files/lpsub-3pck-unselect.png?v=1741908328",
      "https://cdn.shopify.com/s/files/1/2443/2395/files/lpsub-3pck-select.png?v=1741908328",

      // 240 / 4pck
      "https://cdn.shopify.com/s/files/1/2443/2395/files/dr_s_qty_240_unselected.png?v=1769628260",
      "https://cdn.shopify.com/s/files/1/2443/2395/files/dr_s_qty_240_selected.png?v=1769628260", 

      // Toggle icons (also helps prevent flicker on purchase toggles)
      "https://cdn.shopify.com/s/files/1/2443/2395/files/Toggle_Button_-_Selected.png?v=1741909396",
      "https://cdn.shopify.com/s/files/1/2443/2395/files/Toggle_Button_-_Unselected.png?v=1741909396",
      "https://cdn.shopify.com/s/files/1/2443/2395/files/Toggle_Button_-_Selected.png?v=1741908329",
      "https://cdn.shopify.com/s/files/1/2443/2395/files/Toggle_Button_-_Unselected.png?v=1741908329"
    ];

    VARIANT_BTN_BG_URLS.forEach((url) => {
      const img = new Image();
      img.decoding = "async";
      img.loading = "eager";
      img.src = url;
    });
  })();
  
  /***** Update Subscribe Info (Buy Online) *****/
  function updateSubscribeInfo() {
    const subscribeInfo = document.querySelector('#bun-subscribe-btn .bun-subscribe-info');
    if (!subscribeInfo) return;
    const comparePriceSpan = subscribeInfo.querySelector('.bun-compare-price');
    const actualPriceSpan = subscribeInfo.querySelector('.bun-actual-price');
    if (selectedBuyVariantKey === 'single') {
      comparePriceSpan.textContent = "$42.00";
      actualPriceSpan.textContent = "$38";
    } else if (selectedBuyVariantKey === 'threePack') {
      comparePriceSpan.textContent = "$126.00";
      actualPriceSpan.textContent = "$91.20";
    } else if (selectedBuyVariantKey === 'fourPack') {
      comparePriceSpan.textContent = "$211.96";
      actualPriceSpan.textContent = "$148.20";
    }

updateCustomTitlesBasedOnSelection();

  }
  
  /***** Update OTP Info (Buy Online) *****/
  function updateOTPInfo() {
    const otpInfo = document.querySelector('#bun-otp-btn .bun-subscribe-info');
    if (otpInfo) {
      const comparePriceSpan = otpInfo.querySelector('.bun-compare-price');
      const actualPriceSpan = otpInfo.querySelector('.bun-actual-price');
      if (selectedBuyVariantKey === 'single') {
        comparePriceSpan.textContent = "$42.00";
        actualPriceSpan.textContent = "$42";
      } else if (selectedBuyVariantKey === 'threePack') {
        comparePriceSpan.textContent = "$126.00";
        actualPriceSpan.textContent = "$100.80";
      } else if (selectedBuyVariantKey === 'fourPack') {
        comparePriceSpan.textContent = "$211.96";
        actualPriceSpan.textContent = "$156.00";
      }
    }
    const bundleOtpInfo = document.querySelector('#bun-bundle-otp-btn .bun-subscribe-info');
    if (bundleOtpInfo) {
      const comparePriceSpan = bundleOtpInfo.querySelector('.bun-compare-price');
      const actualPriceSpan = bundleOtpInfo.querySelector('.bun-actual-price');
      if (selectedBuyVariantKey === 'single') {
        comparePriceSpan.textContent = "$42.00";
        actualPriceSpan.textContent = "$42";
      } else if (selectedBuyVariantKey === 'threePack') {
        comparePriceSpan.textContent = "$126.00";
        actualPriceSpan.textContent = "$100.80";
      } else if (selectedBuyVariantKey === 'fourPack') {
        comparePriceSpan.textContent = "$211.96";
        actualPriceSpan.textContent = "$156.00";
      }
    }
  }
  
  /***** Update Bundle Subscribe Info *****/
  function updateBundleSubscribeInfo() {
    const bundleSubscribeInfo = document.querySelector('#bun-bundle-subscribe-btn .bun-subscribe-info');
    if (!bundleSubscribeInfo) return;
    const comparePriceSpan = bundleSubscribeInfo.querySelector('.bun-compare-price');
    const actualPriceSpan = bundleSubscribeInfo.querySelector('.bun-actual-price');
    if (selectedBundleVariantKey === 'antiAging') {
      comparePriceSpan.textContent = "$71.99";
      actualPriceSpan.textContent = "$61.75";
    } else if (selectedBundleVariantKey === 'powerDad') {
      comparePriceSpan.textContent = "$119.95";
      actualPriceSpan.textContent = "$102.55";
    }

updateCustomTitlesBasedOnSelection();

  }
  
  /***** Update Bundle OTP Info *****/
  function updateBundleOTPInfo() {
    const bundleOtpInfo = document.querySelector('#bun-bundle-otp-btn .bun-subscribe-info');
    if (!bundleOtpInfo) return;
    const comparePriceSpan = bundleOtpInfo.querySelector('.bun-compare-price');
    const actualPriceSpan = bundleOtpInfo.querySelector('.bun-actual-price');
    if (selectedBundleVariantKey === 'antiAging') {
      comparePriceSpan.textContent = "$71.99";
      actualPriceSpan.textContent = "$65.00";
    } else if (selectedBundleVariantKey === 'powerDad') {
      comparePriceSpan.textContent = "$119.95";
      actualPriceSpan.textContent = "$107.95";
    }
  }
  
  /***** Update Add to Cart Button (Buy Online) *****/
  function updateAddToCartButton() {
    const btn = document.getElementById('bun-add-to-cart-btn');
    let price = "";
    if (document.getElementById('bun-subscribe-btn').classList.contains('active')) {
      if (selectedBuyVariantKey === 'single') {
        price = "$38";
      } else if (selectedBuyVariantKey === 'threePack') {
        price = "$91.20";
      } else if (selectedBuyVariantKey === 'fourPack') {
        price = "$148.20";
      }
    } else {
      if (selectedBuyVariantKey === 'single') {
        price = "$42";
      } else if (selectedBuyVariantKey === 'threePack') {
        price = "$100.80";
      } else if (selectedBuyVariantKey === 'fourPack') {
        price = "$156.00";
      }
    }
    btn.textContent = "Add to cart – " + price;
  }
  
  /***** Update Add to Cart Button (Bundle) *****/
  function updateBundleAddToCartButton() {
    const btn = document.getElementById('bun-bundle-add-to-cart-btn');
    let price = "";
    if (document.getElementById('bun-bundle-subscribe-btn').classList.contains('active')) {
      if (selectedBundleVariantKey === 'antiAging') {
        price = "$61.75";
      } else if (selectedBundleVariantKey === 'powerDad') {
        price = "$102.55";
      }
    } else {
      if (selectedBundleVariantKey === 'antiAging') {
        price = "$65.00";
      } else if (selectedBundleVariantKey === 'powerDad') {
        price = "$107.95";
      }
    }
    btn.textContent = "Add to cart – " + price;
  }

/***** Update Custom Titles Based on Selection *****/
function updateCustomTitlesBasedOnSelection() {
  const custTitle = document.querySelector('.cust-title');
  const custSubTitle = document.querySelector('.cust-sub-title');
  const custSubTitle2 = document.querySelector('.cust-sub-title-2');

  if (!custTitle || !custSubTitle || !custSubTitle2) return;

  if (currentTab === "bundle") {
    if (selectedBundleVariantKey === 'antiAging') {
      custTitle.textContent = "Anti Aging Bundle";
      custSubTitle.textContent = "NAD+ & Sirtuin Activation";
      custSubTitle2.textContent = "30 Day Supply";
    } else if (selectedBundleVariantKey === 'powerDad') {
      custTitle.textContent = "The Power Dad Stack";
      custSubTitle.textContent = "T-Booster & NAD3®";
      custSubTitle2.textContent = "1 Month Supply";
    }
  } else if (currentTab === "buy") {
    if (selectedBuyVariantKey === 'single') {
      custTitle.textContent = "NAD3® | 1 Month Supply";
      custSubTitle.textContent = "Cellular Health & Longevity";
      custSubTitle2.textContent = "60 Capsules | 312mg per serving";
    } else if (selectedBuyVariantKey === 'threePack') {
      custTitle.textContent = "NAD3® | 3 Month Supply";
      custSubTitle.textContent = "Cellular Health & Longevity";
      custSubTitle2.textContent = "180 Capsules | 312mg per serving";
    } else if (selectedBuyVariantKey === 'fourPack') {
      custTitle.textContent = "NAD3® | 4 Month Supply";
      custSubTitle.textContent = "Cellular Health & Longevity";
      custSubTitle2.textContent = "240 Capsules | 312mg per serving";
    }
  }
}

  
/***** Update Banner, Highlight List, and Free Gift Visibility *****/
function updateBannerAndHighlight() {
  const saveBanner = document.getElementById('save-banner');
  const highlightList = document.querySelector('#bun-subscribe-btn .bun-highlight-list');
  
  // Set the save banner text based on variant
  if (selectedBuyVariantKey === 'single') {
    if (saveBanner) saveBanner.textContent = "Save 9.52%";
  } else if (selectedBuyVariantKey === 'threePack') {
    if (saveBanner) saveBanner.textContent = "Save 27.62%";
  } else if (selectedBuyVariantKey === 'fourPack') {
    if (saveBanner) saveBanner.textContent = "Save 30%";
  }
  
  // Build the base list items common for all variants
let listHTML = `<li>Save ${selectedBuyVariantKey === 'single' ? "9.52%" : selectedBuyVariantKey === 'threePack' ? "27.62%" : "30%"} forever</li>`;
if (selectedBuyVariantKey !== 'single') {
  listHTML += '<li>Free U.S. shipping (excluding NY) <span class="sml-banner">$7.99 Value</span></li>';
}
listHTML += '<li>Free Longevity and Better Energy eBooks <span class="sml-banner">$40 Value</span></li>';
  
  // Insert additional list items based on variant selection
  if (selectedBuyVariantKey === 'threePack') {
    listHTML += `<li>Free Shaker <span class="sml-banner">$15 Value</span></li>`;
    listHTML += `<li>Free S9<span style="font-size: 10px; vertical-align: super;">®</span> 1-Week Pouch <span class="sml-banner">$12.99 Value</span></li>`;
  } else if (selectedBuyVariantKey === 'fourPack') {
    listHTML += `<li>Free S9<span style="font-size: 10px; vertical-align: super;">®</span> 1-Week Pouch <span class="sml-banner">$12.99 Value</span></li>
                 <li>Free N4<span style="font-size: 10px; vertical-align: super;">®</span> 1-Week Pouch <span class="sml-banner">$12.99 Value</span></li>
                 <li>Free NAD3<span style="font-size: 10px; vertical-align: super;">®</span> 1-Week Pouch <span class="sml-banner">$12.99 Value</span></li>`;
  }
  
  // Add the final list item common for all variants.
  listHTML += `<li>No commitments, cancel anytime</li>`;
  
  // Update the highlight list if it exists.
  if (highlightList) {
    highlightList.innerHTML = listHTML;
  }
}

  
  /***** Update Progress Bar *****/
  function updateProgressBar() {
    const progressFill = document.querySelector('.bun-progress-bar-fill');
    if (!progressFill) return;
    if (selectedBuyVariantKey === 'single') {
      progressFill.style.width = "33.33%";
    } else if (selectedBuyVariantKey === 'threePack') {
      progressFill.style.width = "66.66%";
    } else if (selectedBuyVariantKey === 'fourPack') {
      progressFill.style.width = "100%";
    }
  }
  
/***** Update New Progress Section *****/
function updateNewProgressSection() {
  const row1 = document.querySelector('.new-progress-row1');
  const row2 = document.querySelector('.new-progress-row2 img');
  const row3 = document.querySelector('.new-progress-row3');
  const row4 = document.querySelector('.new-progress-row4');
  if (!row1 || !row2 || !row3 || !row4) return;

  if (purchaseType === "otp") {
    row1.textContent = "COMMIT TO YOUR HEALTH, GET REWARDED";
    row2.loading = "eager";
    row2.decoding = "async";
    row2.src = "https://cdn.shopify.com/s/files/1/2443/2395/files/Dr_S_Freebie_Progress_0.png?v=1769563271";
    row3.innerHTML = "Get $86.96 worth of FREE GIFTS with your subscription.";
    row4.textContent = "UNLOCK FREE GIFTS by Subscribing to NAD3®";
    return;
  }

  if (selectedBuyVariantKey === 'single') {
    row1.textContent = "COMMIT TO YOUR HEALTH, GET REWARDED";
    row2.loading = "eager";
    row2.decoding = "async";
    row2.src = "https://cdn.shopify.com/s/files/1/2443/2395/files/dr_s_buy_box_top_freebies_1b.png?v=1779317766";
    row3.innerHTML = "Congrats! You’re getting our Longevity and Better Energy eBooks, for FREE!";
    row4.textContent = "Add our 3-month or 4-month supply to unlock more gifts.";
  } else if (selectedBuyVariantKey === 'threePack') {
    row1.textContent = "COMMIT TO YOUR HEALTH, GET REWARDED";
    row2.loading = "eager";
    row2.decoding = "async";
    row2.src = "https://cdn.shopify.com/s/files/1/2443/2395/files/dr_s_buy_box_top_freebies_3b.png?v=1779317768";
    row3.innerHTML = "Congrats! You’re getting our Longevity and Better Energy eBooks, Free Shipping, Premium Shaker Cup, and S9 1-Week Pouch, for FREE!";
    row4.textContent = "Add our 4-month supply to unlock more gifts.";
    } else if (selectedBuyVariantKey === 'fourPack') {
      row1.textContent = "YOUR FREE GIFTS!";
      row2.loading = "eager";
      row2.decoding = "async";
      row2.src = "https://cdn.shopify.com/s/files/1/2443/2395/files/dr_s_buy_box_top_freebies_4b.png?v=1779317770";
      row3.innerHTML = "Congrats! You’re getting our Longevity and Better Energy eBooks, Free Shipping, S9 1-Week Pouch, NAD3 1-Week Pouch, and N4 1-Week Pouch, for FREE!";
      row4.textContent = "You’re getting $86.96 worth of FREE GIFTS!";
      
      if (!confettiTriggeredFor4pck) {
        // Fire confetti only once:
        const progressSection = document.getElementById('new-progress-section');
        confetti({
          particleCount: 50,
          spread: 60,
          origin: { x: 0.5, y: 0.5 },
          colors: ['#082944', '#ffc106', '#3f84ae']
        });
        confettiTriggeredFor4pck = true;
      } else if (purchaseType === "subscription") {
        // Apply scaling effect each time fourPack is selected with subscription active:
        const progressSection = document.getElementById('new-progress-section');
        progressSection.classList.add('scale-up');
        setTimeout(() => {
          progressSection.classList.remove('scale-up');
        }, 500);
      }
    }

}


/***** Update Progress Visuals Section *****/
function updateProgressVisualsSection() {
  const row1 = document.querySelector('#progress-visuals-section .progress-visuals-row1');
  const row2Img = document.querySelector('#progress-visuals-section .progress-visuals-row2 img');
  const row3 = document.querySelector('#progress-visuals-section .progress-visuals-row3');
  if (!row1 || !row2Img || !row3) return;
  
  
  
  if (purchaseType === "subscription") {
    // Reset row1 opacity for subscription state.
    row1.style.opacity = "1";
    
    if (selectedBuyVariantKey === 'single') {
      row2Img.loading = "eager";
      row2Img.decoding = "async";
      row2Img.src = "https://cdn.shopify.com/s/files/1/2443/2395/files/dr_s_buy_box_bottom_freebies_1b.png?v=1779317758";
      row3.style.display = 'none';
    } else if (selectedBuyVariantKey === 'threePack') {
      row2Img.loading = "eager";
      row2Img.decoding = "async";
      row2Img.src = "https://cdn.shopify.com/s/files/1/2443/2395/files/dr_s_buy_box_bottom_freebies_3b.png?v=1779317761";
      row3.style.display = 'none';
    } else if (selectedBuyVariantKey === 'fourPack') {
      row2Img.loading = "eager";
      row2Img.decoding = "async";
      row2Img.src = "https://cdn.shopify.com/s/files/1/2443/2395/files/dr_s_buy_box_bottom_freebies_4b.png?v=1779317763";
      row3.style.display = 'block';
    }
  } else if (purchaseType === "otp") {
    row1.style.opacity = "0.2";
    row2Img.loading = "eager";
    row2Img.decoding = "async";
    row2Img.src = "https://cdn.shopify.com/s/files/1/2443/2395/files/Dr_S_All_Freebies_Hidden.png?v=1769561999";
    row3.style.display = 'none';
  }
}





  /***** Update Custom Titles *****/
  function updateCustomTitles() {
    const custTitle = document.querySelector('.cust-title');
    const custSubTitle2 = document.querySelector('.cust-sub-title-2');
    if (!custTitle || !custSubTitle2) return;
    
    if (selectedBuyVariantKey === 'threePack') {
      custTitle.textContent = "NAD3® | 3 Month Supply";
      custSubTitle2.textContent = "60 Capsules | 312mg per serving";
    } else if (selectedBuyVariantKey === 'fourPack') {
      custTitle.textContent = "NAD3® | 4 Month Supply";
      custSubTitle2.textContent = "240 Capsules | 312mg per serving";
    } else {
      custTitle.textContent = "NAD3® | 1 Month Supply";
      custSubTitle2.textContent = "60 Capsules | 312mg per serving";
    }
  }

  /***** Generic Toggle Image Update *****/
  function updateToggleImageForId(id) {
    const el = document.getElementById(id);
    if (el) {
      const img = el.querySelector('.bun-toggle-icon');
      if (img) {
        if (el.classList.contains('active')) {
          if (id.includes("bun-bundle")) {
            img.src = "https://cdn.shopify.com/s/files/1/2443/2395/files/Toggle_Button_-_Selected.png?v=1741908329";
          } else {
            img.src = "https://cdn.shopify.com/s/files/1/2443/2395/files/Toggle_Button_-_Selected.png?v=1741909396";
          }
        } else {
          if (id.includes("bun-bundle")) {
            img.src = "https://cdn.shopify.com/s/files/1/2443/2395/files/Toggle_Button_-_Unselected.png?v=1741908329";
          } else {
            img.src = "https://cdn.shopify.com/s/files/1/2443/2395/files/Toggle_Button_-_Unselected.png?v=1741909396";
          }
        }
      }
    }
  }

/***** Update OCU Button Visibility *****/
function updateOCUButtonVisibility() {
  // First, hide all custom OCU forms and the original add-to-cart button
  document.getElementById('custom-add-to-cart-form-variant1').style.display = 'none';
  document.getElementById('custom-add-to-cart-form-variant1-subscription').style.display = 'none';
  document.getElementById('custom-add-to-cart-form-variant2').style.display = 'none';
  document.getElementById('custom-add-to-cart-form-variant2-subscription-90').style.display = 'none';
  document.getElementById('bun-add-to-cart-btn').style.display = 'none';

  // For 1pck (or "Once a month" frequency which sets selectedBuyVariantKey to 'single'):
  if (selectedBuyVariantKey === 'single') {
    if (purchaseType === "subscription") {
      document.getElementById('custom-add-to-cart-form-variant1-subscription').style.display = 'block';
      window.selectedOCUForm = document.getElementById('custom-add-to-cart-form-variant1-subscription');
    } else {
      document.getElementById('custom-add-to-cart-form-variant1').style.display = 'block';
      window.selectedOCUForm = document.getElementById('custom-add-to-cart-form-variant1');
    }
  }
  // For 3pck (or "Every 3 months" frequency which sets selectedBuyVariantKey to 'threePack'):
  else if (selectedBuyVariantKey === 'threePack') {
    if (purchaseType === "subscription") {
      // In this setup, we want to use the variant 2 OCU form for Every 3 months.
      document.getElementById('custom-add-to-cart-form-variant2-subscription-90').style.display = 'block';
      window.selectedOCUForm = document.getElementById('custom-add-to-cart-form-variant2-subscription-90');
    } else {
      document.getElementById('custom-add-to-cart-form-variant2').style.display = 'block';
      window.selectedOCUForm = document.getElementById('custom-add-to-cart-form-variant2');
    }
  }
  // For 4pck:
  else if (selectedBuyVariantKey === 'fourPack') {
    // When 4pck is selected, show the original add-to-cart button
    document.getElementById('bun-add-to-cart-btn').style.display = 'block';
    window.selectedOCUForm = null;
  }
}

  
  /***** Tab Switching *****/
  const tabBuy = document.getElementById('bun-tab-buy');
  const tabBundle = document.getElementById('bun-tab-bundle');
  const buyContainer = document.getElementById('bun-buy-online-container');
  const bundleContainer = document.getElementById('bun-bundle-save-container');
  
function switchTab(tab) {
  currentTab = tab;
  if (tab === "buy") {
tabBuy.classList.add('active');
tabBundle.classList.remove('active');
if (typeof confettiTriggered !== 'undefined' && confettiTriggered) {
  // If the reveal has already happened, show the Buy Online Container
  buyContainer.style.display = 'block';
  // Optionally, hide the reveal cover once it’s been triggered
  document.getElementById('reveal-cover').style.display = 'none';
} else {
  // If the reveal hasn't happened yet, keep Buy Online Container hidden,
  // but ensure that the reveal cover is visible
  buyContainer.style.display = 'none';
  document.getElementById('reveal-cover').style.display = 'block';
}
bundleContainer.style.display = 'none';

// FORCE BUY ONLINE DEFAULT TO 3PCK SUBSCRIBE CONFIGURATION
selectedBuyVariantKey = "threePack";
purchaseType = "subscription";

  // Remove active class from all buy variant buttons in the container
  document.querySelectorAll('#bun-buy-online-container .bun-variant-button').forEach(btn => btn.classList.remove('active'));
  // Activate the 1pck (single) button
  const defaultBuyBtn = document.querySelector('#bun-buy-online-container .bun-variant-button[data-variant="threePack"]');

  if (defaultBuyBtn) {
    defaultBuyBtn.classList.add('active');
  }

  // Update all related UI components for the 1pck subscribe configuration
  updateFrequencyButtons();
  updateSubscribeInfo();
  updateOTPInfo();
  updateBannerAndHighlight();
  updateProgressBar();
  updateNewProgressSection();
  updateProgressVisualsSection();
  updateAddToCartButton();
  updateOCUButtonVisibility();
  updateCustomTitles();
    
  } else {
    tabBuy.classList.remove('active');
    tabBundle.classList.add('active');
    buyContainer.style.display = 'none';
    document.getElementById('reveal-cover').style.display = 'none';

    bundleContainer.style.display = 'block';
    
    // Set default for Bundle & Save
    selectedBundleVariantKey = "antiAging";
    // Remove active class from all bundle variant buttons
    document.querySelectorAll('#bun-bundle-save-container .bun-variant-button')
      .forEach(btn => btn.classList.remove('active'));
    // Add active class to the antiAging button
    const defaultBtn = document.querySelector('#bun-bundle-save-container .bun-variant-button[data-variant="antiAging"]');
    if (defaultBtn) {
      defaultBtn.classList.add('active');
    }
    
    updateBundleSubscribeInfo();
    updateBundleOTPInfo();
    updateBundleAddToCartButton();
  }
  updateCustomTitlesBasedOnSelection();
}

  
  tabBuy.addEventListener('click', () => switchTab("buy"));
  tabBundle.addEventListener('click', () => switchTab("bundle"));
  
  /***** Variant Selection *****/
  const variantButtons = document.querySelectorAll('.bun-variant-button');
  
  variantButtons.forEach(button => {
    button.addEventListener('click', function() {
      const containerId = this.closest('.bun-container').id;
      this.closest('.bun-container').querySelectorAll('.bun-variant-button').forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');
      if (containerId === "bun-buy-online-container") {
        selectedBuyVariantKey = this.getAttribute('data-variant');
        
        updateFrequencyButtons();
        updateSubscribeInfo();
        updateOTPInfo();
        updateBannerAndHighlight();
        updateProgressBar();
        updateNewProgressSection();
      updateProgressVisualsSection(); // NEW call to update visuals
        updateAddToCartButton();
        updateCustomTitles(); // NEW: update the custom titles based on the variant selected
updateOCUButtonVisibility();
      } else if (containerId === "bun-bundle-save-container") {
        selectedBundleVariantKey = this.getAttribute('data-variant');
        
        updateBundleSubscribeInfo();
        updateBundleOTPInfo();
        updateBundleAddToCartButton();
      }
    });

updateCustomTitlesBasedOnSelection();

  });
  
  /***** Purchase Type Toggle *****/
  const subscribeBtn = document.getElementById('bun-subscribe-btn');
  const otpBtn = document.getElementById('bun-otp-btn');
  
  subscribeBtn.addEventListener('click', () => {
    subscribeBtn.classList.add('active');
    otpBtn.classList.remove('active');
    purchaseType = "subscription";
    
    updateFrequencyButtons();
    updateToggleImageForId('bun-subscribe-btn');
    updateToggleImageForId('bun-otp-btn');
    updateBannerAndHighlight();
    updateAddToCartButton();
updateOCUButtonVisibility();
  updateNewProgressSection(); // Trigger progress section update for subscription
  updateProgressVisualsSection(); // NEW call for subscription update
  });
  
  otpBtn.addEventListener('click', () => {
    otpBtn.classList.add('active');
    subscribeBtn.classList.remove('active');
    purchaseType = "otp";
    
    updateFrequencyButtons();
    updateToggleImageForId('bun-subscribe-btn');
    updateToggleImageForId('bun-otp-btn');
    updateBannerAndHighlight();
    updateAddToCartButton();
updateOCUButtonVisibility();
  updateNewProgressSection(); // Trigger progress section update for OTP
  updateProgressVisualsSection(); // NEW call for OTP update
  });
  
  const bundleSubscribeBtn = document.getElementById('bun-bundle-subscribe-btn');
  const bundleOtpBtn = document.getElementById('bun-bundle-otp-btn');
  
  bundleSubscribeBtn.addEventListener('click', () => {
    bundleSubscribeBtn.classList.add('active');
    bundleOtpBtn.classList.remove('active');
    purchaseType = "subscription";
    
    updateToggleImageForId('bun-bundle-subscribe-btn');
    updateToggleImageForId('bun-bundle-otp-btn');
    updateBundleAddToCartButton();
  });
  
  bundleOtpBtn.addEventListener('click', () => {
    bundleOtpBtn.classList.add('active');
    bundleSubscribeBtn.classList.remove('active');
    purchaseType = "otp";
    
    updateToggleImageForId('bun-bundle-subscribe-btn');
    updateToggleImageForId('bun-bundle-otp-btn');
    updateBundleAddToCartButton();
  });
  
/***** Frequency Buttons Update *****/
function updateFrequencyButtons() {
  const frequencyOptions = document.getElementById('bun-frequency-options');
  if (purchaseType !== "subscription") {
    frequencyOptions.style.display = 'none';
    return;
  }
  frequencyOptions.style.display = 'flex';

  // Hide the blue, orange, and red sets.
  document.querySelectorAll(
    '#bun-frequency-options .bun-frequency-set--blue, #bun-frequency-options .bun-frequency-set--orange, #bun-frequency-options .bun-frequency-set--red'
  ).forEach(set => {
    set.style.display = 'none';
  });

  // Always show the green frequency set and update its active button based on selectedBuyVariantKey.
  let greenSet = document.querySelector('#bun-frequency-options .bun-frequency-set--green');
  if (greenSet) {
    greenSet.style.display = 'flex';
    // Remove active class from all green buttons
    greenSet.querySelectorAll('.bun-frequency-button').forEach(btn => btn.classList.remove('active'));
    
    // Based on the current selectedBuyVariantKey, activate the corresponding green frequency button
    if (selectedBuyVariantKey === 'single') {
      let btn = greenSet.querySelector('.bun-frequency-button[data-plan-id="5116493961"]');
      if (btn) btn.classList.add('active');
    } else if (selectedBuyVariantKey === 'threePack') {
      let btn = greenSet.querySelector('.bun-frequency-button[data-plan-id="5704745097"]');
      if (btn) btn.classList.add('active');
    } else if (selectedBuyVariantKey === 'fourPack') {
      let btn = greenSet.querySelector('.bun-frequency-button[data-plan-id="5116362889"]');
      if (btn) btn.classList.add('active');
    }
  }
}



  
  document.querySelectorAll('.bun-frequency-set--blue .bun-frequency-button').forEach(button => {
    button.addEventListener('click', function() {
      if (this.classList.contains('disabled')) return;
      this.parentElement.querySelectorAll('.bun-frequency-button').forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');
      if (selectedBuyVariantKey === 'single') {
        selectedFrequencyPlanId = this.getAttribute('data-plan-id');
        
      }
    });
  });
  
  document.querySelectorAll('.bun-frequency-set--orange .bun-frequency-button').forEach(button => {
    button.addEventListener('click', function() {
      if (this.classList.contains('disabled')) return;
      this.parentElement.querySelectorAll('.bun-frequency-button').forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');
      if (selectedBuyVariantKey === 'threePack') {
        selectedFrequencyPlanIdThreePack = this.getAttribute('data-plan-id');
        
      }
    });
  });
  
  document.querySelectorAll('.bun-frequency-set--red .bun-frequency-button').forEach(button => {
    button.addEventListener('click', function() {
      if (this.classList.contains('disabled')) return;
      this.parentElement.querySelectorAll('.bun-frequency-button').forEach(btn => btn.classList.remove('active'));
      this.classList.add('active');
      if (selectedBuyVariantKey === 'fourPack') {
        selectedFrequencyPlanIdFourPack = this.getAttribute('data-plan-id');
        
      }
    });
  });

document.querySelectorAll('.bun-frequency-set--green .bun-frequency-button').forEach(button => {
  button.addEventListener('click', function() {
    if (this.classList.contains('disabled')) return;
    // Remove active class from all buttons in the green set
    this.parentElement.querySelectorAll('.bun-frequency-button').forEach(btn => btn.classList.remove('active'));
    this.classList.add('active');
    
    let planId = this.getAttribute('data-plan-id');
    
    
    // Set flag to indicate the green set is active
    selectedFrequencySet = "green";
    
    // Update selectedBuyVariantKey and frequency plan IDs based on the selected plan
    if (planId === "5116493961") {
      selectedBuyVariantKey = 'single';
      selectedFrequencyPlanId = planId;
    } else if (planId === "5704745097") {
      selectedBuyVariantKey = 'threePack';
      selectedFrequencyPlanIdThreePack = planId;
    } else if (planId === "5116362889") {
      selectedBuyVariantKey = 'fourPack';
      selectedFrequencyPlanIdFourPack = planId;
    }
    
    // Update the variant buttons to reflect the new selection
    document.querySelectorAll('.bun-variant-button').forEach(btn => btn.classList.remove('active'));
    const variantBtn = document.querySelector(`.bun-variant-button[data-variant="${selectedBuyVariantKey}"]`);
    if (variantBtn) {
      variantBtn.classList.add('active');
    }
    
    // Update all pricing, progress, and UI elements
    updateSubscribeInfo();
    updateOTPInfo();
    updateBannerAndHighlight();
    updateProgressBar();
updateNewProgressSection();
    updateAddToCartButton();
    updateCustomTitles();

    // New call to update the visible OCU form based on the frequency button selection
    updateOCUButtonVisibility();
  });
});



  
  /***** Add to Cart Functionality *****/
  function addToCart(purchaseType) {
    let payload;
    if (currentTab === "buy") {
      const variantData = variants[selectedBuyVariantKey];
      if (purchaseType === "subscription") {
        if (selectedBuyVariantKey === 'single') {
          payload = { id: variantData.variantId, quantity: 1, selling_plan: selectedFrequencyPlanId };
        } else if (selectedBuyVariantKey === 'threePack') {
          payload = { id: variantData.variantId, quantity: 1, selling_plan: selectedFrequencyPlanIdThreePack };
        } else if (selectedBuyVariantKey === 'fourPack') {
          payload = { id: variantData.variantId, quantity: 1, selling_plan: selectedFrequencyPlanIdFourPack };
        }
      } else {
        payload = { id: variantData.variantId, quantity: 1 };
      }
    } else {
      if (purchaseType === "subscription") {
        if (selectedBundleVariantKey === "antiAging") {
          payload = { id: bundleVariants.antiAging.variantId, quantity: 1, selling_plan: bundleVariants.antiAging.sellingPlan };
        } else if (selectedBundleVariantKey === "powerDad") {
          payload = { id: bundleVariants.powerDad.variantId, quantity: 1, selling_plan: bundleVariants.powerDad.sellingPlan };
        }
      } else {
        const variantData = bundleVariants[selectedBundleVariantKey];
        payload = { id: variantData.variantId, quantity: 1 };
      }
    }
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(response => response.json())
    .then(data => {
      
      window.location.href = '/cart';
    });
  }
  
  document.getElementById('bun-add-to-cart-btn').addEventListener('click', () => { addToCart(purchaseType); });
  document.getElementById('bun-bundle-add-to-cart-btn').addEventListener('click', () => { addToCart(purchaseType); });
  
  // Initialize all components on page load.
  updateFrequencyButtons();
  updateSubscribeInfo();
  updateOTPInfo();
  updateBannerAndHighlight();
  updateProgressBar();
updateNewProgressSection();
updateProgressVisualsSection();
  updateAddToCartButton();
  updateBundleAddToCartButton();
  updateToggleImageForId('bun-subscribe-btn');
  updateToggleImageForId('bun-otp-btn');
  updateToggleImageForId('bun-bundle-otp-btn');
  updateBundleSubscribeInfo();
  updateBundleOTPInfo();
updateOCUButtonVisibility();
